import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination
} from "@mui/material";
import VMSheader from "./vmsheader";
import { getAPI } from "../network";
import {  timeFormat } from "../utils";
import "./style.css";

export default function History() {
  const [history, setHistory] = useState([]);

  // Global visitor type from localStorage
  const visitorTypeGlobal = localStorage.getItem("visitorType");

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getHistory();
  }, []);

  const getHistory = async () => {
    const data = await getAPI("/visitor/book/history");
    if (data) {
      setHistory(data);
    }
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Slice the history for the current page
  const displayedHistory = history.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Grid container justifyContent="center" sx={{ p: 2 }}>
      <Box sx={{ width: "90%", maxWidth: 1000 }}>
        <VMSheader />

        <Typography
          className="title-font"
          variant="h5"
          sx={{ my: 2, fontWeight: 800, fontFamily: "Poppins" }}
        >
          My History
        </Typography>

        {/* Visitor Type Section */}
        {/* <Box
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            textAlign: "center"
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Visitor Type: {visitorTypeGlobal ? visitorTypeGlobal : "N/A"}
          </Typography>
        </Box> */}

        {/* Table Section */}
        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#457B9D",
                    color: "white",
                    fontWeight: "bold"
                  }}
                >
                  Check In Date & Time
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#457B9D",
                    color: "white",
                    fontWeight: "bold"
                  }}
                >
                  Site Name
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#457B9D",
                    color: "white",
                    fontWeight: "bold"
                  }}
                >
                  Visitor Type
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedHistory.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {item.visitDate.split("T")[0]} ({timeFormat(item.checkIn)})
                  </TableCell>
                  <TableCell>{item?.siteId?.name}</TableCell>
                  <TableCell>
                    {item.visitorType ? item.visitorType : visitorTypeGlobal || "N/A"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* Pagination controls */}
          <TablePagination
            component="div"
            count={history.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 20, 50]}
          />
        </TableContainer>
      </Box>
    </Grid>
  );
}
